module.exports = __webpack_public_path__ + "img/ctrl-u-stub-up-0.531959f0.svg";